export default __webpack_public_path__ + "static/media/logo.5d71b1e7.png";